import React, {useEffect} from 'react';
import {BrowserRouter as Router, Route } from 'react-router-dom';
import {login, logout, selectUser} from './features/userSlice';
import {useDispatch, useSelector} from 'react-redux';
import Header from './Header';
import './App.css';
import Feed from './Feed';
import Login from './Login';
import Sidebar from './Sidebar';
import SidebarRight from './SidebarRight';
import { auth } from './firebase';
//import Widgets from './Widgets';
import News from './News';
import Chat from './Chat';
//<Widgets/>

function App() {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  useEffect(() => {
  auth.onAuthStateChanged(userAuth => {
    if(userAuth) {
      //user is logged in
      dispatch(
        login({
        email: userAuth.user.email,
        uid: userAuth.uid,
        displayName:userAuth.displayName,
        photoUrl: userAuth.photoURL,
      }));
    } else {
      //user is logged out
      dispatch(logout());
    }
  })
},[dispatch]);

return (
  <Router>
      <div className="app">
      {!user ? (
        <Login/>
        ) : (
      <>
      <Header/>
      <div className="app__chat">
        <Route path="/chat" exact>
          <Sidebar/>
          <Chat /> 
          <SidebarRight/>
        </Route>
      </div>
      <div className="app__home">
        <Route path="/" exact >
          <Sidebar/>
          <Feed/>
          <SidebarRight/>
        </Route>
      </div>
      <div className="app__news">
        <Route path="/news" exact>
          <Sidebar/>
          <News /> 
          <SidebarRight/>
        </Route>
      </div>
      </>
      )}
      </div>
  </Router>
  );
}
export default App;
